import React from "react";
import { Typography, IconButton } from "@mui/material";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import {
  StyledCard,
  StyledCardContent,
  StyledHeaderBox,
  StyledMetricValue,
  StyledRiskBar,
  StyledRiskSegment,
  StyledStatContainer,
} from "./InsightCardShared";
import StatItem from "./StatItem";
import { useTranslation } from "react-i18next";

interface InsightCardRisksProps {
  title: string;
  risks: {
    high: number;
    medium: number;
    low: number;
  };
  onClick?: () => void;
}

const InsightCardRisks: React.FC<InsightCardRisksProps> = ({
  title,
  risks,
  onClick,
}) => {
  const { t } = useTranslation();
  const total = risks.high + risks.medium + risks.low;

  return (
    <StyledCard
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default" }}
    >
      <StyledCardContent>
        <StyledHeaderBox>
          <Typography variant="subtitle2">{title}</Typography>
          <IconButton
            size="small"
            sx={{
              color: "primary.main",
              "&:hover": {
                backgroundColor: "primary.light",
                color: "white",
              },
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </StyledHeaderBox>

        <StyledMetricValue variant="h3" color="primary">
          {total}
        </StyledMetricValue>

        <StyledRiskBar>
          <StyledRiskSegment color="error" width={(risks.high / total) * 100} />
          <StyledRiskSegment
            color="warning"
            width={(risks.medium / total) * 100}
          />
          <StyledRiskSegment
            color="#ffa468"
            width={(risks.low / total) * 100}
          />
        </StyledRiskBar>

        <StyledStatContainer>
          <StatItem label={t("High")} value={risks.high} labelColor="error" />
          <StatItem
            label={t("Medium")}
            value={risks.medium}
            labelColor="warning"
          />
          <StatItem label={t("Low")} value={risks.low} labelColor="#ffa468" />
        </StyledStatContainer>
      </StyledCardContent>
    </StyledCard>
  );
};

export default InsightCardRisks;
